import { render } from "./MyEdit.vue?vue&type=template&id=9df38834&scoped=true"
import script from "./MyEdit.vue?vue&type=script&lang=js"
export * from "./MyEdit.vue?vue&type=script&lang=js"

import "./MyEdit.vue?vue&type=style&index=0&id=9df38834&scoped=true&lang=css"

import exportComponent from "D:\\main\\spacelab\\cinema-cms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9df38834"]])

export default __exports__